import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { SplitFactory } from '@splitsoftware/splitio';
export class SplitClient {
  constructor(user, authorizationKey) {
    let extraAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    this.user = user;
    this.authorizationKey = authorizationKey;
    this.extraAttributes = extraAttributes;
    _defineProperty(this, "splitClient", null);
    _defineProperty(this, "startPromise", null);
    _defineProperty(this, "courseId", undefined);
    _defineProperty(this, "getAnonymousKey", () => {
      return 'anonymous_no_snowplow_cookie';
    });
  }
  setCourseId(courseId) {
    this.courseId = courseId;
  }
  setExtraAttributes(extraAttributes) {
    this.extraAttributes = extraAttributes;
  }
  getFeatureFlags(featureFlagNames) {
    if (this.splitClient === null) {
      throw new Error('SplitClient is not initialized');
    }
    const flags = this.splitClient.getTreatments(featureFlagNames, this.getAttributes());
    return flags;
  }
  getFeatureFlag(featureFlagName) {
    if (this.splitClient === null) {
      throw new Error('SplitClient is not initialized');
    }
    const flag = this.splitClient.getTreatment(featureFlagName, this.getAttributes());
    return flag;
  }
  async start() {
    if (this.startPromise === null) {
      this.startPromise = new Promise(resolve => {
        const splitFactory = SplitFactory({
          core: {
            authorizationKey: this.authorizationKey,
            key: this.getKey()
          },
          startup: {
            readyTimeout: 1.5
          }
        });
        this.splitClient = splitFactory.client();
        this.splitClient.once(this.splitClient.Event.SDK_READY_TIMED_OUT, () => {
          resolve();
        });
        this.splitClient.once(this.splitClient.Event.SDK_READY, () => {
          resolve();
        });
      }).finally(() => {
        if (this.splitClient !== null) {
          this.splitClient.removeAllListeners();
        }
      });
    }
    return this.startPromise;
  }
  getAttributes() {
    return _objectSpread(_objectSpread({}, this.courseId != null ? {
      courseId: this.courseId
    } : {}), {}, {
      hasActiveSubscription: this.user.hasActiveSubscription,
      isAnonymous: !this.user.isLoggedIn
    }, this.extraAttributes);
  }
  getKey() {
    if (this.user.id !== undefined) {
      return this.user.id.toString();
    }
    return this.getAnonymousKey();
  }
}